export default __webpack_public_path__ + "static/media/link.81bb44cb.svg";